import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const IconHome = () => (
  <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const Navbar = () => {
  return (
    <nav className="bg-white border-b border-gray-200 px-4">
      <div className="max-w-4xl mx-auto flex items-center justify-between h-14">
        <Link to="/" className="flex items-center gap-2 font-bold text-xl text-gray-900 hover:no-underline">
          <Logo size={34} />
          <span>UtilitEase</span>
        </Link>
        <Link to="/" className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors">
          <IconHome />
          <span>Home</span>
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
